import React from 'react';
import PropTypes from 'prop-types';

export const ButtonLink = ({ className, isDisabled, children, onClick, ...rest }) => (
  <span
    className={className}
    onClick={!isDisabled ? onClick : undefined}
    {...rest}
  >
    {children}
  </span>
);

ButtonLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

ButtonLink.defaultProps = {
  className: '',
  onClick: () => {},
  children: null,
  isDisabled: false,
};

export default ButtonLink;
